<template>
	<div v-if="user">
		<div class="white-box">
			<loading :active="loading"/>
			<template v-if="qrError">
				<div class="alert alert-danger">
					<strong>{{ qrError }}</strong>
				</div>
			</template>
			<qrcode-stream @init="onInit" @decode="onDecode" :paused="paused"></qrcode-stream>
		</div>
	</div>
</template>

<script>
	import { QrcodeStream } from 'vue-qrcode-reader'
	import VueElementLoading from 'vue-element-loading'
	export default {
		props: ['user', 'isAuth'],
		components: {
			'qrcode-stream': QrcodeStream,
			'loading': VueElementLoading,
		},
		data () {
			return {
				loading: true,
				paused: false,
				qrError: null,
			}
		},
		methods: {
			async onInit(promise) {
				this.error = null
				try {
					await promise
				} catch (error) {
					if(error.name === 'NotAllowedError') {
						// user denied camera access permisson
						this.qrError = 'Denied camera access permisson'
						console.log('NotAllowedError')
					} else if(error.name === 'NotFoundError') {
						// no suitable camera device installed
						this.qrError = 'No suitable camera device installed'
						console.log('NotFoundError')
					} else if (error.name === 'NotSupportedError') {
						// page is not served over HTTPS (or localhost)
						this.qrError = 'Page is not served over HTTPS (or localhost)'
						console.log('NotSupportedError')
					} else if (error.name === 'NotReadableError') {
						// maybe camera is already in use
						this.qrError = 'Maybe camera is already in use'
						console.log('NotReadableError')
					} else if (error.name === 'OverconstrainedError') {
						// passed constraints don't match any camera.
						// Did you requested the front camera although there is none?
						this.qrError = 'Passed constraints don\'t match any camera. Did you requested the front camera although there is none?'
						console.log('OverconstrainedError')
					} else if (error.name === 'StreamApiNotSupportedError') {
						// browser seems to be lacking features
						this.qrError = 'Browser seems to be lacking features'
						console.log('StreamApiNotSupportedError')
					}
				} finally {
					this.loading = false
				}
			},
			onDecode(decodedString) {
				this.paused = true
				var url = new URL(decodedString);
				var path = url.pathname
				this.$router.push(path)
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/qrCodeReader/layout/qrCodeReader.vue